import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import firebase from '../../Firebase/index';
import AdmissionDetails from '../../Firebase/Firestore/AdmissionDetails';

export default function AdmissionDetail({ children }) {
  const [dbClient, setDbClient] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [admissionDetail, setAdmissionDetail] = useState({});
  useEffect(() => {
    const user = firebase.auth().currentUser;
    const db = new AdmissionDetails(firebase, user.uid);
    db.listenOnUpdate((source, data) => {
      setAdmissionDetail(data);
      setIsLoading(false);
    });
    setDbClient(db);
    return () => {
      db.unsubscribeListerner();
    };
  }, []);
  return children({
    isLoading,
    admissionDetail,
    onCreateAdmissionDetail: dbClient && dbClient.createData,
    onDeleteAdmissionDetail: dbClient && dbClient.deleteData,
  });
}
